// Adapted from:https://davidwells.io/snippets/get-difference-between-two-objects-javascript

import { isoDateToFormDate } from 'admin/lib/dates'
import _ from 'lodash'

const date_properties = [
  'deliveryArrivalDate',
  'deliveryExitDate',
  'productionTime',
  'usedAtTime',
  'removalDate'
]

function isNotNully(value) {
  return value !== '' && value != null
}

/**
 * Find difference between two objects
 * @param  {object} origObj - Source object to compare newObj against
 * @param  {object} newObj  - New object with potential changes
 * @return {array} differences
 */
export function difference(origObj, newObj) {
  const results = []

  const relevantFieldsObj = {
    data: origObj.data,
    status: origObj.status,
    estimatedAccuracy: origObj.estimatedAccuracy
  }

  function changes(newObj, origObj) {
    const keys = _.union(_.keys(newObj), _.keys(origObj))
    keys.forEach(key => {
      if (
        (date_properties.some(d => d == key) &&
          isoDateToFormDate(origObj[key]) != newObj[key]) ||
        (!date_properties.some(d => d == key) &&
          !_.isEqual(newObj[key], origObj[key]))
      ) {
        if (_.isObject(newObj[key]) && _.isObject(origObj[key])) {
          changes(newObj[key], origObj[key])
        } else if (_.isObject(newObj[key])) {
          changes(newObj[key], {})
        } else if (_.isObject(origObj[key])) {
          changes({}, origObj[key])
        }
        // Skip loop if both sides are null or empty.
        // Can happen on a removed incomplete line/product
        else if (isNotNully(newObj[key]) || isNotNully(origObj[key])) {
          results.push({
            field: key,
            newValue: isNotNully(newObj[key]) ? newObj[key] : null,
            oldValue: isNotNully(origObj[key]) ? origObj[key] : null
          })
        }
      }
    })
  }
  changes(newObj, relevantFieldsObj)
  return results
}
